// Usage
// <app-agreement-status-chip [agreementStatus]="agreement.status"></app-agreement-status-chip>

import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-agreement-status-chip',
  templateUrl: './agreement-status-chip.component.html',
  styleUrls: ['./agreement-status-chip.component.scss'],
})
export class AgreementStatusChipComponent {
  // get agreement status from parent component
  @Input() agreementStatus: string;
}
